import { ArrowRight, ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { cn } from '@loop3/ui'
import type { LinkItem } from '@/lib/tools'

const ROW =
  'group flex items-start gap-3 px-4 py-4 border-b border-border/60 hover:bg-[var(--l3-violet-soft)] transition-colors'

/** One hub link: icon, title, description; in-app routes navigate, URLs open a new tab. */
export function LinkRow({ item }: { item: LinkItem }) {
  const Icon = item.icon
  const Arrow = item.to ? ArrowRight : ArrowUpRight
  const body = (
    <>
      <Icon className="size-4 mt-0.5 shrink-0 opacity-70 transition-colors group-hover:opacity-100 group-hover:text-[var(--l3-violet)]" />
      <div className="min-w-0 flex-1">
        <h4 className="text-sm font-medium transition-colors group-hover:text-[var(--l3-violet)]">
          {item.title}
        </h4>
        <p className="mt-1 text-xs leading-relaxed opacity-60">
          {item.description}
        </p>
      </div>
      <Arrow
        aria-hidden
        className="size-3.5 mt-1 shrink-0 opacity-30 transition-opacity group-hover:opacity-80"
      />
    </>
  )
  return item.to ? (
    <Link to={item.to} className={ROW}>
      {body}
    </Link>
  ) : (
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className={ROW}
    >
      {body}
    </a>
  )
}

/** A labelled grid of hub links with a count. */
export function LinkSection({
  label,
  unit,
  items,
  className,
}: {
  label: string
  unit: string
  items: readonly LinkItem[]
  className: string
}) {
  return (
    <section>
      <div className="mb-3 flex items-baseline justify-between">
        <h3 className="eyebrow opacity-60">{label}</h3>
        <span className="eyebrow opacity-40">
          {items.length} {unit}
        </span>
      </div>
      <div className={cn('grid grid-cols-1 border-t border-border', className)}>
        {items.map((item) => (
          <LinkRow key={item.id} item={item} />
        ))}
      </div>
    </section>
  )
}
